import { IBlockEventData } from '@src/common/types/empTypes';

export const validateBlockEvent = (blockEvent: IBlockEventData[]) => {
  let validateBlockEventsData = blockEvent;
  // validate event_name
  const isEventNameEmpty = validateBlockEventsData.some(
    (event) => typeof event.event_name === 'undefined',
  );
  if (isEventNameEmpty) {
    return {
      key: ['Block Event Name'],
      result: 'is null',
      status: false,
      data: validateBlockEventsData,
    };
  }
  // remove rule without value of block_rule
  validateBlockEventsData = validateBlockEventsData.map((event) => {
    const blockEventSingleData = { ...event };
    blockEventSingleData.block_rules = blockEventSingleData.block_rules
      ?.map((andRules) => {
        return andRules?.filter((orRuleItem) => {
          // The current key is a fixed value that must exist, so you can leave the key unchecked
          return orRuleItem.value.length;
        });
      })
      .filter((item) => item.length);
    return blockEventSingleData;
  });
  return { data: validateBlockEventsData, status: true };
};
